define('lq/services/mpa/applicationValidation',[
    'module',
    'lq/cssutil'
], function (module, cssutil) {
    'use strict';

    var config = module.config();

    var shortCutKey = 27; // Escape
    var delta = 500;
    var numberToTrigger = 3;

    function ApplicationValidation(annotations) {
        this.annotations = annotations;
        this.presses = 0;
    };

    ApplicationValidation.typeName = 'ApplicationValidation';

    ApplicationValidation.prototype.initialize = function () {
        if (this.annotations.isProductionModeEnabled) {
            this.handler = this.handleKeyUp.bind(this);
            $(document).on('keyup',  this.handler);
        } else {
            this.loadValidator();
        }
    };

    ApplicationValidation.prototype.handleKeyUp = function (event) {
        if (event.keyCode !== shortCutKey)
            return;

        var keyPressTime = new Date();

        if (this.previousKeyPressTime && keyPressTime - this.previousKeyPressTime > delta) {
            this.presses = 1;
            this.previousKeyPressTime = keyPressTime;
        } else if (this.presses === numberToTrigger - 1) {
            this.presses = 0;
            this.previousKeyPressTime = null;
            this.loadValidator();
            $(document).off('keyup', this.handler);
        } else {
            this.presses++;
            this.previousKeyPressTime = keyPressTime;
        }
    };

    ApplicationValidation.prototype.loadValidator = function () {
        cssutil.requireCss(config.cssFile);

        require([
            'lq/licquidRuntimeValidation'
        ], this.start.bind(this));
    };

    ApplicationValidation.prototype.start = function (LicquidRuntimeValidation) {
        var validation = new LicquidRuntimeValidation();
        validation.start(this.rootDrop, this.annotations);
    };

    return ApplicationValidation;
});

